module.exports = __webpack_public_path__ + "img/evergreen.33c70d35.png";